import { useProductPrice } from '../../pricing/queries/useProductPrice';
import usePriceFormatter from '../../core/hooks/usePriceFormatter';
import type { ProductWithFixedRelatedProducts } from '../util/processRelatedProducts';

interface ActiveFormattedProductPriceProps {
    activeSku?: string;
    product: ProductWithFixedRelatedProducts;
}

export const useActiveFormattedProductPrice = ({
    product,
    activeSku,
}: ActiveFormattedProductPriceProps) => {
    const { customerPrice } = useProductPrice({
        product,
        selectedSku: activeSku,
    });

    const priceFormatter = usePriceFormatter();
    return priceFormatter(customerPrice?.retailPrice);
};
